export const FREE_SHIPPING_PROMOTION = /* GraphQL */ `
  query Promotion($identifier: String!) {
    promotion(identifier: $identifier) {
      triggers {
        minValue
      }
    }
  }
`;
